import http from "@/api";

/**
 * 二級認證
 */
export const getFactory = (params) => {
    return http.post(`/api/factory`, params);
};
